module.exports = __webpack_public_path__ + "icon_view_more.e55c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_view_more.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_view_more.svg
// module chunks = main